export default __webpack_public_path__ + "static/media/cathode-pic1.8e4a472f.jpg";